import React from "react";
import Track from "./Track";
import './Tracklist.css';


function Tracklist({ searchResults, setPlaylist, getPreview }) {

    //add track to playlist
    const handleClick = (event) => {
        event.preventDefault();
        const id = event.target.id;

        //Get the track from the search results array
        const newArr = searchResults.filter((track) => track.id === id);
        //convert the returned array into a single object (take only array value)
        const val = newArr[0];
        setPlaylist((prevPlaylist) =>  [...prevPlaylist, val]);
    }

    const handlePreviewClick = (event) => {
        event.preventDefault();
        const id = event.currentTarget.id; //note currentTarget rather than target - this bubbles up to the parent <svg>

        getPreview(id);
    }

    return (
        <div>
            {searchResults.map((track) => {
                return (
                    <div>
                        <Track 
                            name={track.name}
                            artist={track.artist}
                            album={track.album}
                            id={track.id}
                        />
                        <div id="play-add-container">
                            {/* Basic implementation of an SVG acting as the play button */}
                            <svg className="clickableSVG" id={track.id} onClick={handlePreviewClick} width="50" height="50" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Frame 1">
                                    <path id="CyanPlay" d="M65 48.2679C66.3333 49.0377 66.3333 50.9623 65 51.7321L33.5 69.9186C32.1667 70.6884 30.5 69.7261 30.5 68.1865L30.5 31.8135C30.5 30.2739 32.1667 29.3116 33.5 30.0814L65 48.2679Z"  fill-opacity="0.75"/>
                                    <path id="PinkPlay" d="M80 48.2679C81.3333 49.0377 81.3333 50.9623 80 51.7321L48.5 69.9186C47.1667 70.6884 45.5 69.7261 45.5 68.1865L45.5 31.8135C45.5 30.2739 47.1667 29.3116 48.5 30.0814L80 48.2679Z"  fill-opacity="0.75"/>
                                </g>
                            </svg>
                            <button id={track.id} onClick={handleClick}>+</button>
                        </div>
                    </div>
                );
            })
            }
        </div>
    );
}

export default Tracklist;